import { Component, OnInit } from '@angular/core';
import { AddVehiculoComponent } from '../add-vehiculo/add-vehiculo.component'; 
@Component({
  selector: 'app-update-register',
  templateUrl: './update-register.component.html',
  styleUrls: ['./update-register.component.scss'],
  standalone: true, 
  imports: [AddVehiculoComponent], 
})
export class UpdateRegisterComponent implements OnInit {
  vehiculoParaEditar: any = null;

  ngOnInit() {
    const vehiculoStr = sessionStorage.getItem('vechicleParaEditar');
    if (vehiculoStr) {
      this.vehiculoParaEditar = JSON.parse(vehiculoStr);
      sessionStorage.removeItem('vechicleParaEditar');
    }
  }
}
